import type { ReactNode } from 'react'

import { accentStyle } from '@/lib/accent'

/**
 * Applies a restaurant's accent to its subtree (T14: accents only — fills, borders, text;
 * the neutral base stays the app's). `display: contents` keeps it out of the layout.
 */
export function AccentScope({ color, children }: { color: string | null | undefined; children: ReactNode }) {
  return (
    <div className="contents" data-accent-scope style={accentStyle(color)}>
      {children}
    </div>
  )
}
